/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type SearchContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PipelinesContainer_viewer$ref: FragmentReference;
export type PipelinesContainer_viewer = {|
  +id: string,
  +s_time_zone: ?string,
  +pipelines: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +plists: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +position: ?number,
              +plist_events: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +id: string,
                    +position: ?number,
                    +event: ?{|
                      +id: string,
                      +user_event: ?{|
                        +booking_status: ?BookingStatus,
                        +start_at: ?any,
                        +end_at: ?any,
                        +user_event_segments: ?{|
                          +edges: ?$ReadOnlyArray<?{|
                            +node: ?{|
                              +location: ?string,
                              +room: ?string,
                            |}
                          |}>
                        |},
                        +event: ?{|
                          +id: string,
                          +title: ?string,
                          +start_at: ?any,
                          +end_at: ?any,
                        |},
                      |},
                    |},
                  |}
                |}>
              |},
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: SearchContainer_viewer$ref,
  +$refType: PipelinesContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "PipelinesContainer_viewer",
  "type": "User",
  "metadata": {
    "connection": [
      v0,
      v0,
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "pipelines"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "pipelines",
      "name": "__PipelinesContainer_pipelines_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PipelineConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PipelineEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Pipeline",
              "plural": false,
              "selections": [
                v1,
                v2,
                {
                  "kind": "LinkedField",
                  "alias": "plists",
                  "name": "__PipelinesContainer_plists_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PlistConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PlistEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Plist",
                          "plural": false,
                          "selections": [
                            v1,
                            v2,
                            v3,
                            {
                              "kind": "LinkedField",
                              "alias": "plist_events",
                              "name": "__PipelinesContainer_plist_events_connection",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "PlistEventConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "edges",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "PlistEventEdge",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "node",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "PlistEvent",
                                      "plural": false,
                                      "selections": [
                                        v1,
                                        v3,
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "name": "event",
                                          "storageKey": null,
                                          "args": null,
                                          "concreteType": "Event",
                                          "plural": false,
                                          "selections": [
                                            v1,
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "name": "user_event",
                                              "storageKey": null,
                                              "args": null,
                                              "concreteType": "UserEvent",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "name": "booking_status",
                                                  "args": null,
                                                  "storageKey": null
                                                },
                                                v4,
                                                v5,
                                                {
                                                  "kind": "LinkedField",
                                                  "alias": null,
                                                  "name": "user_event_segments",
                                                  "storageKey": "user_event_segments(first:99999)",
                                                  "args": [
                                                    {
                                                      "kind": "Literal",
                                                      "name": "first",
                                                      "value": 99999,
                                                      "type": "Int"
                                                    }
                                                  ],
                                                  "concreteType": "UserEventSegmentConnection",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "kind": "LinkedField",
                                                      "alias": null,
                                                      "name": "edges",
                                                      "storageKey": null,
                                                      "args": null,
                                                      "concreteType": "UserEventSegmentEdge",
                                                      "plural": true,
                                                      "selections": [
                                                        {
                                                          "kind": "LinkedField",
                                                          "alias": null,
                                                          "name": "node",
                                                          "storageKey": null,
                                                          "args": null,
                                                          "concreteType": "UserEventSegment",
                                                          "plural": false,
                                                          "selections": [
                                                            {
                                                              "kind": "ScalarField",
                                                              "alias": null,
                                                              "name": "location",
                                                              "args": null,
                                                              "storageKey": null
                                                            },
                                                            {
                                                              "kind": "ScalarField",
                                                              "alias": null,
                                                              "name": "room",
                                                              "args": null,
                                                              "storageKey": null
                                                            }
                                                          ]
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                },
                                                {
                                                  "kind": "LinkedField",
                                                  "alias": null,
                                                  "name": "event",
                                                  "storageKey": null,
                                                  "args": null,
                                                  "concreteType": "Event",
                                                  "plural": false,
                                                  "selections": [
                                                    v1,
                                                    v2,
                                                    v4,
                                                    v5
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        v6
                                      ]
                                    },
                                    v7
                                  ]
                                },
                                v8
                              ]
                            },
                            v6
                          ]
                        },
                        v7
                      ]
                    },
                    v8
                  ]
                },
                v6
              ]
            },
            v7
          ]
        },
        v8
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchContainer_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b0a3c85bedcfa5fe716bd05bb709fb30';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Pipelines/__generated__/PipelinesContainer_viewer.graphql.js